<template>
	<div>
		<myheader headTitle="合同附件"></myheader>
		<div class="all_main">
			<div class="all_height20"
				style="position: fixed;top: 4rem;left: 0; right: 0; background-color: white;z-index: 10;display: flex;padding: 0 .5rem">
				<div @click="showSelectFile()" class="all_height20 display_flex display_inline_block"
					style="width: 75%;overflow: hidden;padding: .6rem 0;">
					<img src="@/assets/images/dropdown.svg"
						style="display: inline-block;width: 8%;padding-top: .2rem; object-fit: contain;"
						:class="{rotate:reslistShow}" />
					<div class="text12 textcolor333 display_inline_block"
						style="width: 90%; height: .8rem;margin-left: 2%; overflow: hidden;">
						{{resText}}
					</div>
				</div>
				<div style="display: inline-block;width: 25%;display: flex;padding: .4rem 0;">
					<span @click="prevFileClick()" class="text12 all_text_center all_line_height12"
						style="display: inline-block;width: 49.8%;"
						:class="{textcolormain:currentShowDoc.prevIframeID,textcolor999:!currentShowDoc.prevIframeID}">
						上一篇</span>
					<span class="vertical_line" style="display: inline-block;width: 0.4%;"></span>
					<span @click="nextFileClick()" class="text12 all_text_center all_line_height12"
						style="display: inline-block;width: 49.8%;"
						:class="{textcolormain:currentShowDoc.nextIframeID,textcolor999:!currentShowDoc.nextIframeID}">下一篇</span>
				</div>
			</div>
			<div class="all_list_content_nopadding" id="pdfcontainer" style="top: 6.2rem;background-color: white;"
				:style="{'bottom':contractStatus === '1'?'3.6rem':'0.2rem'}">
			</div>
			<div id="reslist"
				style="position: absolute;left: 0;right:0;background-color: white;	transition: top .3s linear 0s;"
				:style="{'top':reslistTop}">
				<div class="horizontal_line"></div>
				<div v-for="(item,index) in resList" :key="index" @click="selectEditFileIndex(item,index)">
					<div class="text12 all_height_line16" style="padding: 0 .5rem;"
						:class="{textcolor333:currentShowDocIndex === index,textcolor999:currentShowDocIndex != index}">
						{{item.resName}}
					</div>
					<div class="horizontal_line"></div>
				</div>
			</div>
		</div>
		<div class="all_tips_bottom_card" v-if="contractStatus === '1'">
			<button class="all_button24 width_100 text16 backgroundC_main bmain_active"
				@click="downFileClick()">下载</button>
		</div>
	</div>
</template>

<script>
	import {
		setEssToken
	} from "../../utils/cookies.js";
	import {
		getDeviceType,
		saveFileToDownloads,
		fromateDownloadPath
	} from '../../utils/nativeOtherOperate.js'
	import {
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				//合同id
				contractId: '',
				//合同状态
				contractStatus: '1',
				//文件列表top值
				reslistTop: 0,
				//文件列表是否显示
				reslistShow: false,
				//文档列表
				resList: [],
				//选中文档名称
				resText: '',
				//当前iframe 对象
				currentShowDoc: '',
				//当前iframe index
				currentShowDocIndex: 0,
				//所有文档iframe  map对象
				currentDocumentObject: {},
				//签章后刷新页面恢复滑动高度
				currentDocumentScrollTop: [],
				//iframe高度
				iframeHeight: '',
				//
				timeOutEvent: null,
			}
		},
		methods: {
			//下载当前附件文件
			downFileClick() {
				let that = this
				this.resList.forEach((doc, idx) => {
					if (this.currentShowDocIndex === idx) {
						const header = 'Bearer ' + window.localStorage.getItem("Identity_Token")
						const url = window.location.origin + process.env.VUE_APP_API_BASE_URL_MSIGN +
							'/file/api/downloadActFile?fileId=' + doc.fileId + '&resName=' + encodeURIComponent(doc.resName)
						switch (getDeviceType()) {
							case 'android':
							case 'ios':
								let time = Date.now()
								let fileName = '_downloads/document_' + time + '.pdf'
								let aFileName = fromateDownloadPath('downloads/document_' + time + '.pdf')
								this.$store.dispatch(this.$LoadShow, true)
								this.$store.dispatch(this.$LoadText, '下载中...')
								let task = plus.downloader.createDownload(url, {
									filename: fileName,
									verifyCertificate: false
								}, function(d, status) {
									that.$store.dispatch(that.$LoadShow, false)
									that.$store.dispatch(that.$LoadText, '加载中...')
									if (status === 200) {
										//console.log('aFileName--=', aFileName)
										if (saveFileToDownloads(aFileName, doc.resName + '.pdf')) {
											that.$Toast('下载文件成功')
										}else{
											that.$Toast('下载文件失败，请重试！')
										}
									} else {
										that.$Toast('下载文件失败，请重试！')
									}
								})
								task.setRequestHeader('Authorization', header);
								task.start()
								break
							case 'harmony':
								this.$store.dispatch(this.$LoadShow, true)
								this.$store.dispatch(this.$LoadText, '下载中...')
								harmonyEsign.downFileToSanBox(header, url)
									.then(res => {
										//console.log('downFileToSanBox-1-=', res)
										if (res) {
											harmonyEsign.copySanFileToManager(res).then(rel => {
												//console.log('copySanFileToManager-=', rel)
												that.$store.dispatch(that.$LoadShow, false)
												that.$store.dispatch(that.$LoadText, '加载中...')
												if(rel){
													that.$Toast('下载文件成功')
												}else{
													that.$Toast('下载文件失败，请重试！')
												}
											}).catch(err => {
												console.log('copySanFileToManager-err-=', err)
												that.$store.dispatch(that.$LoadShow, false)
												that.$store.dispatch(that.$LoadText, '加载中...')
												that.$Toast('下载文件失败，请重试！')
											})
										}else{
											that.$store.dispatch(that.$LoadShow, false)
											that.$store.dispatch(that.$LoadText, '加载中...')
											that.$Toast('下载文件失败，请重试！')
										}
									}).catch(err => {
										console.log('downFileToSanBox-err-=', err)
										that.$store.dispatch(that.$LoadShow, false)
										that.$store.dispatch(that.$LoadText, '加载中...')
										that.$Toast('下载文件失败，请重试！')
									})
								break;
						}
					}
				})
			},
			//上一篇
			prevFileClick() {
				this.dimissFileList()
				if (this.currentShowDoc.prevIframeID) {
					const previousIs = this.currentDocumentObject[this.currentShowDoc.prevIframeID];
					document.getElementById(previousIs.currentIframeName).style.display = 'block';
					document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
					this.currentShowDoc = previousIs;
					document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
					this.currentShowDocIndex = this.currentShowDoc.originIdx
					this.resText = this.currentShowDoc.documentName
				} else {
					//this.$Toast('当前已是第一份文档');
				}
			},
			//下一篇
			nextFileClick() {
				this.dimissFileList()
				if (this.currentShowDoc.nextIframeID) {
					const nextIs = this.currentDocumentObject[this.currentShowDoc.nextIframeID];
					document.getElementById(nextIs.currentIframeName).style.display = 'block';
					document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
					this.currentShowDoc = nextIs;
					document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
					this.currentShowDocIndex = this.currentShowDoc.originIdx
					this.resText = this.currentShowDoc.documentName
				} else {
					//this.$Toast('当前已是最后一份文档')
				}
			},
			//隐藏文件列表
			dimissFileList() {
				if (this.reslistShow) {
					let fontsize = document.firstElementChild.style.fontSize.replace('px', '')
					this.reslistTop = Number(fontsize) * 6 - document.getElementById("reslist").clientHeight + 'px'
					this.reslistShow = false
				}
				window.localStorage.setItem('ResListShow', this.reslistShow)
			},
			//显示文件列表
			showSelectFile() {
				if (this.reslistShow) {
					let fontsize = document.firstElementChild.style.fontSize.replace('px', '')
					this.reslistTop = Number(fontsize) * 6 - document.getElementById("reslist").clientHeight + 'px'
					this.reslistShow = false
				} else {
					this.reslistTop = '6rem'
					this.reslistShow = true
				}
				window.localStorage.setItem('ResListShow', this.reslistShow)
			},
			//选择显示文件
			selectEditFileIndex(item, index) {
				this.resText = item.resName
				if (item.docId != this.currentShowDoc.documentID) {
					const nextIs = this.currentDocumentObject[item.docId];
					document.getElementById(nextIs.currentIframeName).style.display = 'block';
					document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
					this.currentShowDoc = nextIs;
					document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
					this.currentShowDocIndex = this.currentShowDoc.originIdx
				}
				this.dimissFileList()
			},
			//获取附件列表
			getContractResActList() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/getContractDetail?contractId=" + this.contractId)
					.then((res) => {
						if (res.success && res.data) {
							//console.log('res-=', res)
							this.contractInfo = res.data
							this.resList = res.data.resList
							this.resText = this.resList[0].resName
							this.currentDocumentObject = []
							this.iframeHeight = document.getElementById('pdfcontainer').clientHeight
							let theFrag = document.createDocumentFragment()
							this.resList.forEach((doc, idx) => {
								this.getIframeSrc(theFrag, doc, idx)
							})
						} else {
							this.$store.dispatch(this.$LoadShow, false)
							this.$Toast(res.message || '没有获取到附件文件，请返回重试!')
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast('没有获取到附件文件，请返回重试!')
						console.log('getContractResActList', err)
					});
			},
			//
			getIframeSrc(theFrag, doc, idx) {
				const fileUrl = process.env.VUE_APP_API_BASE_URL_MSIGN + '/file/api/downloadActFile?fileId=' + doc.fileId +
					'&resName=' + encodeURIComponent(doc.resName)
				doc.src = window.location.origin + process.env.VUE_APP_PREVIEW_URL + '/h5/preview/preview.html?file=' +
					encodeURIComponent(fileUrl) + '&Authorization=Bearer ' + window.localStorage.getItem("Identity_Token")
				this.setIframeSrc(theFrag, doc, idx)
			},
			//
			setIframeSrc(theFrag, doc, idx) {
				let data = this.resList.filter(item => {
					return !item.src
				})
				if ((Array.isArray(data) && data.length === 0) || !data) {
					this.resList.forEach((doc, idx) => {
						let iframeName = 'Iframe' + idx;
						this.currentDocumentObject[doc.docId] = {
							documentType: doc.isAttachment,
							attachment: doc.isAttachment,
							documentName: doc.resName,
							documentID: doc.docId,
							fileID: doc.resId,
							originIdx: idx,
							currentIframeName: iframeName,
							prevIframeID: idx === 0 ? null : this.resList[idx - 1].docId,
							nextIframeID: idx === this.resList.length - 1 ? null : this.resList[
								idx + 1].docId
						};
						let theIframe = document.createElement('iframe');
						theIframe.setAttribute('id', iframeName);
						theIframe.setAttribute('class', 'iframe-style');
						theIframe.setAttribute('style', 'display: none;height:' + this
							.iframeHeight + 'px');
						// 把第1个文档作为默认显示文档
						if (idx === this.currentShowDocIndex) {
							this.currentShowDoc = this.currentDocumentObject[doc.docId];
							theIframe.setAttribute('style', 'display: block;height:' + this
								.iframeHeight + 'px');
							this.currentShowDocIndex = idx
						}
						console.log('-src--=', doc, idx)
						theIframe.setAttribute('src', doc.src);
						//console.log('theIframe',theIframe)
						theFrag.appendChild(theIframe);
					})
					document.getElementById('pdfcontainer').appendChild(theFrag)
				}
			},
			//接受处理iframe消息
			handlerMessage() {
				let that = this
				window.addEventListener('message', (event) => {
					let postData = event.data.data;
					if (postData && postData.type) {
						switch (postData.type) {
							//显示iframe中的消息
							case 'toast':
								that.$Toast(postData.data)
								break;
								//pdf滑动时条件弹窗消失
							case 'ResListShow':
								that.dimissFileList()
								//console.log('FileListShow')
								break;
								//pdf加载时改弹窗消失
							case 'loaded':
								//console.log('加载消失')
								that.$store.dispatch(that.$LoadShow, false)
								break;
							case 'loading':
								//console.log('加载消失')
								that.$store.dispatch(that.$LoadShow, true)
								break;
							case 'qrcode':
								console.log('qrcode', postData)
								// if (postData && postData.data) {
								// 	let tmp = postData.data.split('||')
								// 	if (tmp[1]) {
								// 		Dialog.confirm({
								// 				title: '提示',
								// 				message: '识别到合同二维码内容：' + tmp[1] + '，需要跳转到存证报告页面吗？',
								// 				confirmButtonText: '确定',
								// 				confirmButtonColor: '#0277FC'
								// 			})
								// 			.then(() => {
								// 				that.$router.push({
								// 					path: '/contractevidenceinfo',
								// 					query: {
								// 						contractCode: that.contractInfo.contractCode,
								// 					}
								// 				})
								// 			})
								// 			.catch(() => {});
								// 	}
								// }
								break;
						}
					}
				})
			},
			//初始化
			init() {
				this.contractId = this.$route.query.contractId
				this.contractStatus = this.$route.query.contractStatus
				this.getContractResActList()
				this.handlerMessage()
				//匹配不同的平台
				//合同滑动时 是否通知本页面
				window.localStorage.setItem('ResListShow', this.reslistShow)
			},
		},
		mounted() {
			this.init()
		},
		created() {},
		beforeDestroy() {
			//自动回收
			this.$store.dispatch(this.$LoadText, '加载中...')
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>